import { z } from 'zod';

export const feedbackSchema = z.object({
  topicId: z.string().min(1, 'Please select a topic'),
  message: z.string().min(10, 'Please enter your feedback'),
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  email: z.string().email('Invalid email address'),
  phone: z
    .string()
    .optional()
    .refine((v) => !v || /^\+?[0-9\-\s]{7,15}$/.test(v), { message: 'Invalid phone number' }),
  companyName: z.string().optional(),
});

export type FeedbackFormValues = z.infer<typeof feedbackSchema>;
